module.exports = {"events":"Events","description":"Select the Event you want to transfer to:","cancel":"Cancel","select":"Select an event","transfer":"Transfer"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Payout/EventsModal/locales/en.json
// module id = 1948
// module chunks = 0